/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Tag,
  Modal,
  Space,
  message,
  Typography,
  Row,
  Col,
  Descriptions,
  Image,
} from 'antd';
import { PlayCircleTwoTone } from '@ant-design/icons';
import { guuid } from '@/utils/utils';
import styles from './index.less';
import ModalVideo from '../ModalVideoKp';
import ClassActionView from '../ClassActionView';

const { Paragraph } = Typography;

const ClassCommentView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { visible, setVisible, detailRecord, infoList } = props;
  return (
    <div>
      <Modal
        title="点评详情"
        width={1000}
        visible={visible}
        onOk={() => {
          setVisible(false);
        }}
        onCancel={() => {
          setVisible(false);
        }}
      >
        <ClassActionView detailRecord={detailRecord} infoList={infoList} />
      </Modal>
    </div>
  );
};

export default ClassCommentView;
